import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { DestinationsInitStepDeclaration } from "./Steps/DestinationsInitStep";

export const DestinationsStartupFlow = new FlowDefinition("DestinationsFlow");

DestinationsStartupFlow.addStep(DestinationsInitStepDeclaration);

DestinationsStartupFlow.setStartStep("DestinationsInit_Step");

export const DestinationsStartupStepDefinition = new StepDefinition({
    stepName: "DestinationsFlow",
    stepFlow: DestinationsStartupFlow,
    contextIsolation: false
})